import { Component,  OnInit, EventEmitter, Output, Input } from '@angular/core';
import { DocumentService } from '../../../../../../UI/src/app/shared/document-upload/document-upload.service';
import { TranslateService } from '@ngx-translate/core'
import { NavController, NavParams, Events, LoadingController } from 'ionic-angular';
import { SettingsService } from '../../../../../../UI/src/app/shared/settings/settings.service';
import { ToastControllerService } from '../../../../providers/toast-controller.service';
import { Toast508Service } from '../../../../providers/toast-508.service';
import { ResumeService } from '../../../../../../UI/src/app/shared/resume/resume.service';
import { ProfileService } from '../../../../../../UI/src/app/shared/profile/profile.service';
import { DocumentUploadComponent } from '../document-upload/document-upload.component';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'sts-document-import',
  templateUrl: 'document-import.component.html',
})

export class DocumentImportComponent implements OnInit {
  @Input() data: any;
  @Input() edit = false;
  @Input() attachOnly = false;
  @Output() update = new EventEmitter<any>();
  documentTypes: any;
  public translations: any;
  alertData: any;
  candidateDocumentTranslations: any;
  public newFile = null;
  showLoader = false;
  public dataAttach = null;
  public videoFileUpload = false;
  public addNew = false;
  public addNewURL = false;
  public newURL = null;
  public dataURL = null;
  public loading;
  private imgURL: any;
  private fileSource: any = 4;
  public currentDocumentIndex: number;
  private getFileSizeKey = 'ELIXHRUI_SUPPORTED_FILE_SIZE';
  public fileSizeSetting: any;
  private fileSizeExceedMessage: any;
  private maxFileSizeMessage: any;
  private isFileUploaded = false;
  private isUploadCompleted = false;
  private documentImportForm: FormGroup;
  uploadProgress: any;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public events: Events,
    public documentService: DocumentService,
    private translate: TranslateService,
    private settingsService: SettingsService,
    private toastService: ToastControllerService,
    public loadingCtrl: LoadingController,
    public resumeService: ResumeService,
    private profileService: ProfileService,
    private toast508Service: Toast508Service,
    private formBuilder: FormBuilder,
    ) {
      this.translate.get(['CAREER_MAXIMUM_FILE_SIZE','CAREER_INVALID_DOCUMENT']).subscribe((obj) => {
        this.translations = obj;
      });
      this.loading = this.loadingCtrl.create({
        duration: 15000
      });
      this.currentDocumentIndex = this.navParams.get("index");      
    
       this.data = this.navParams.data;   

        this.documentImportForm = this.formBuilder.group({
          fileName: ['', Validators.required],
          fileDescription : ['', Validators.required],
          uploadFile : ['', Validators.required]
      });    
  }

  ngOnInit() {
      this.newFile = {};
      if(this.data){
      this.populateValues();
      }

      this.settingsService.GetSettings().subscribe(
        settings => {
      this.fileSizeSetting = settings.filter(setting => setting.key === this.getFileSizeKey)[0].value;
      this.fileSizeSetting = this.fileSizeSetting / (1024 * 1024);
      this.maxFileSizeMessage = this.translations['CAREER_MAXIMUM_FILE_SIZE'].replace('{{fileSizeSetting}}', this.fileSizeSetting);
        }
      );
  }

  private populateValues() {
    if (this.data.documentType && this.data.documentType.fileAssetId != 0) {                 
      this.newFile.name = this.data.documentType.fileName; 
      this.newFile.description = this.data.documentType.fileDescription;       
    }
    this.navCtrl.getPrevious().data.isFromPreviousPage = false;
  }

  saveNewFile() {
    const formData: FormData = new FormData();
    formData.append('DisplayName', this.newFile.name);
    formData.append('Description', this.newFile.description);
    formData.append('uploadFile', this.newFile.fileLocation);
    formData.append('FileSource', this.fileSource);
    formData.append('SourceObjectId', 'initiativeFileUploads');    
    this.formDataUpload(formData);
  }

  saveDocumentDetails() { 
    this.isUploadCompleted = true; 
    this.saveNewFile();      
  }

  fileChange(event: any) {    
    if (event && event.target.files) {
      const fileList: FileList = event.target.files;
      if (fileList.length > 0) {
        const file = fileList[0];
        const fileSize = file.size / (1024 * 1024);
        const filevalid = this.checkFileFormat(file.name, fileSize);
        if (filevalid.sizeofFile && filevalid.typeofFile) {
        this.newFile.fileLocation = fileList[0];
        this.newFile.fileName = fileList[0].name;       
        this.isFileUploaded = true;          
        this.preview(file);              
        } else {
          if (!filevalid.typeofFile) {
            this.alertData = { message: this.translations['CAREER_INVALID_DOCUMENT'], type: 'error' };
          } else if (!filevalid.sizeofFile) {
            this.alertData = { message: this.fileSizeExceedMessage, type: 'error' };
          }       
          this.toastService.presentToast(this.alertData);
          this.toast508Service.toFocus();
      }
    }
  }
}

  private checkFileFormat(name, size) {
    const docFileParams = {
      fileSize: this.fileSizeSetting,
      fileType: ['image/*', 'audio/*', 'video/*', 'text/plain', '.doc', '.docm', '.docx', '.xls', '.xlsm', '.xlsx',
        '.oda', '.odc', '.odh', '.odl', '.odp', '.ods', '.odt', '.7z', '.zip', '.rar', '.png', '.gif', '.jpg', '.jpeg',
        '.js', '.css', '.htm', '.html', '.mpg', '.mp4', '.mpeg', '.avi', '.mov', '.mp3', '.wmv', '.pdf', '.txt', '.csv', '.pptx', '.ppt',
        '.json']
    };
    const fileParams = {
      typeofFile: false,
      sizeofFile: false
    };
    if (docFileParams.fileType.indexOf(name.toLowerCase().substring(name.lastIndexOf('.'))) !== -1) {
      fileParams.typeofFile = true;
      if (size <= docFileParams.fileSize) {
        fileParams.sizeofFile = true;
      }
      return fileParams;
    } else {
      return fileParams;
    }
  }

  cancel(){
    this.navCtrl.pop();
  }

  removeItem() {
    this.isFileUploaded = false;         
  }

  addItem() {
    if (!this.addNew) {
      this.newFile = {};
      this.addNew = true;
    }
  }

  addURL() {
    if (!this.addNewURL) {
      this.newURL = {
        'attachmentType': 'URL'
      };
      this.addNewURL = true;
    }
  }

  private showFileUploadError(filevalid) {
    var alertData;
    if (!filevalid.typeofFile) {
      alertData = { message: this.translations['CAREER_INVALID_DOCUMENT'], type: 'error' };
    } else if (!filevalid.sizeofFile) {
      alertData = { message: this.fileSizeExceedMessage, type: 'error' };
    }
    this.toast508Service.toFocus();
  }

  private formDataUpload(formData) {    
    this.Upload(formData);
  }

  Upload(fileData: any) {
    this.profileService.upload(fileData, pct => {this.fileProgress(pct); }, res => { this.fileSuccess(res); }, error => { this.fileError(error);});
  }

  fileProgress(progressAmount: any) {    
    this.uploadProgress = progressAmount;
  }

  fileSuccess(response: any) {
    this.isUploadCompleted = false;
    this.loading.dismiss();
    var fileDets = JSON.parse(response.returnData)
    var index = this.currentDocumentIndex;
        
    this.documentService.documentTypes[index].fileAssetId = fileDets.id;
    this.documentService.documentTypes[index].fileName = this.newFile.name;
    this.documentService.documentTypes[index].fileDescription = this.newFile.description;    
    this.saveDocument();
  } 

  saveDocument(){
    this.documentService.saveDocumentTypes(this.documentService.documentTypes, false)
    .subscribe((response) => {
      this.loading.dismiss();          
      this.navCtrl.getPrevious().data.isUploadSuccess = true;
      this.navCtrl.getPrevious().data.isFromPreviousPage = true;          
      this.navCtrl.pop();  
    }), (error) => {
      this.loading.dismiss();
      this.navCtrl.getPrevious().data.isUploadSuccess = false;
      console.log("file uploaded failed", error);
    }
  }

  fileError(error: any) {
    this.loading.dismiss();
        console.log("file uploaded failed", error);
  }

  private sendUpdate() {
    this.update.emit({
      attachments: this.dataAttach.concat(this.dataURL)
    });
  }


  preview(file) {
    const mimeType = file.type;
    if (mimeType.match(/image\/*/) == null) {
      this.imgURL = null;
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/candidate-profile/document-import/document-import.component.ts